"use strict";

import {findAll, on, removeClass, addClass} from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-gdpr__checkbox', function (element) {

        on('change', (evt) => {
            let checkbox = evt.target;
            let downloadBtns = findAll('.js-gdpr__button');
            let gdprCheckboxes = findAll('.js-gdpr__checkbox');

            if (checkbox.checked){
                downloadBtns.forEach(function(btn) {
                   removeClass('disabled',btn);
                });

                gdprCheckboxes.forEach(function(checkbox) {
                    checkbox.checked = true;
                });
            }else{
                downloadBtns.forEach(function(btn) {
                    addClass('disabled',btn);
                });
                gdprCheckboxes.forEach(function(checkbox) {
                    checkbox.checked = false;
                });
            }

        }, element)
    });
}